export enum LabelPlacement {
  END = 'end',
  START = 'start',
  TOP = 'top',
  BOTTOM = 'bottom',
}
